import styled from '~/app/components/styled'
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '~/app/components/common/Button/Button'
import { useMemo } from 'react'
import useGoHome from '~/app/utils/useGoHome'
import { Typography } from '@yanolja-rnd/ya-com-core'

/**
 * EmptyList component
 * author: soojin.oh
 */

// type definitions
type EmptyListProps = {
  isChangedSearchFilter: boolean
  selectedPeriod: { title: string; id: string }
}

// styled components
const Container = styled.div`
  padding-top: 13.2rem;
  background: ${({ theme: { color } }) => color.white};
  height: 100%;
`

const Content = styled.div`
  padding: 3.2rem 2.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const ButtonContainer = styled.div`
  width: 16rem;
  height: 3.6rem;
`
const Title = styled.div`
  text-align: center;
  ${Typography('subtitle3').regular};
  color: ${({ theme }) => theme.color.gray900};
  margin: 0 0 0.4rem;
`
const SubTitle = styled.div`
  text-align: center;
  ${Typography('body1').regular};
  color: ${({ theme }) => theme.color.gray600};
  margin: 0 0 1.6rem;
`

// EmptyList component
const EmptyList: React.FunctionComponent<EmptyListProps> = function ({
  isChangedSearchFilter,
  selectedPeriod,
}) {
  const title = useMemo(
    () =>
      isChangedSearchFilter
        ? '조건에 맞는 예약내역이 없어요'
        : `${selectedPeriod.title}간 예약한 상품이 없어요`,
    [isChangedSearchFilter]
  )

  const { goHome } = useGoHome()

  return (
    <Container>
      <Content>
        <Title>{title}</Title>
        <SubTitle>여행 준비의 모든 것, 바로 NOL에서! </SubTitle>
        <ButtonContainer>
          <Button
            type={BUTTON_TYPE.BLUE}
            size={BUTTON_SIZE.M}
            title={'홈으로 가기'}
            onClick={goHome}
            isFullSize={true}
          />
        </ButtonContainer>
      </Content>
    </Container>
  )
}

export default EmptyList
